import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Lighting by Nando Erni</p>
      </header>
    </div>
  );
}

export default App;
